export const AFTER_LOGIN_URL = "/";
export const FORGOT_PASSWORD_URL = "/forgot";
export const LOGIN_URL = "/login";
export const LOGIN_TRANSFER_URL = "/login_transfer";
export const LOGOUT_URL = "/logout";
export const RESET_PASSWORD_URL = "/reset";
export const SETTINGS_URL = "/settings";
